import {c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
import React from "react";
var DialogContext_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  const DialogContext = /* @__PURE__ */ (0, React.createContext)({});
  var _default = DialogContext;
  exports.default = _default;
});
export {DialogContext_1 as D};
